// TAB decision REST client.
//
// getBriefing and getExecutionPreview both used to swallow their errors and return
// a fixed briefing ("p95 latency < 450ms; success metrics achieved") regardless of
// what the demand's stages actually produced — a board could have read that off the
// screen for a demand with no POC at all. Now on the shared client, and errors show.

import { get, post, demandPath, AI_TIMEOUT_MS } from "../../../api/http";

/**
 * AI-stitched briefing across Discovery/POC/Requirements/Security.
 *
 * The response includes `missingEvidence` — stages that produced no result — because
 * the board needs to know what it is deciding without. Cached server-side; pass
 * refresh to rebuild.
 */
export async function getBriefing(demandId, { refresh = false } = {}) {
  return get(demandPath(demandId, "/tab/briefing"), {
    query: refresh ? { refresh: "true" } : undefined,
    timeout: AI_TIMEOUT_MS,
  });
}

/** What the handoff would create in the target tool. Read-only. */
export async function getExecutionPreview(demandId) {
  return get(demandPath(demandId, "/execute/preview"));
}

export async function postTabDecision(demandId, payload) {
  return post(demandPath(demandId, "/tab/decide"), payload);
}

/** Create the objects in the target tool. Rejects unless TAB has approved. */
export async function postExecute(demandId, execPayload = {}) {
  return post(demandPath(demandId, "/execute"), execPayload, { timeout: AI_TIMEOUT_MS });
}
